import PeriprocedureelBeleidTARMonCloAsa from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-mon-clo-asa.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARMonCloAsa,
  ChartCollapse,
  React
};